import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {ResourcesService} from '../../../course/services/resources.service';
import * as _ from 'underscore';
import {Resource} from '../../../domain/media';

@Injectable({providedIn: 'root'})
export class ResourceResolver  {
  constructor(private resourcesService: ResourcesService) {
    console.log('ResourceResolver.constructor');
  }

  resolve(route: ActivatedRouteSnapshot,
          state: RouterStateSnapshot): Promise<Resource> {
    console.log('ResourceResolver.resolve');

    let pspdfkitId = null;
    let courseId = route.paramMap.get('id');
    if (!courseId) {
      courseId = route.data.courseId;
    }
    let code = route.data.code;

    if (route.paramMap.get('pspdfkitId')) {
      pspdfkitId = route.paramMap.get('pspdfkitId');
    } else if (route.queryParamMap.get('pspdfkitId')) {
      pspdfkitId = route.queryParamMap.get('pspdfkitId');
    }

    if (route.paramMap.get('code')) {
      code = route.paramMap.get('code');
    }

    const promise = new Promise<Resource>((resolve, reject) => {
      if (courseId && code) {
        this.resourcesService.load(courseId).then(value => {
          const library = _.findWhere(value, {code: code});

          let resource = _.find(library.references, (resource) => {
            return resource['media'].pspdfkitId === pspdfkitId;
          });

          resolve(resource);
        });
      } else {
        resolve({
          media: {
            pspdfkitId: pspdfkitId
          }
        });
      }
    });

    return promise;
  }
}
